import api from 'common/api';

export const getHblAPI = (params: any) => api.get('/hbl-status-export/list', params);

export const getHblDocDetailAPI = (params: any) => api.get('/hbl-status-export/document/detail', params);

export const uploadHblDocAPI = (params: any) => api.post('/hbl-status-export/document/upload', params);

export const deleteHblDocAPI = (params: any) => api.put('/hbl-status-export/document/delete', params);

export const validationHblDocAPI = (params: any) => api.get('/hbl-status-export/document/validation', params);

export const DOWNLOAD_APPROVAL_DOCUMENT_API = '/approval-document/download';
